import $ from 'jquery';
require('9.vendors/rAF');

const $siteHeader = $('.site-header');
const $wrap = $('.page-header__top');
const $clone = $('<div class="page-header__spacer" />');
const $title = $('.page-header__title');
const $img = $('.page-header__img');
const TRANSITION_DURATION_IN_PX = 50;

function easeInCubic(t) {
  return t * t * t;
}

function easeInOutQuart(t) { return t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t; }

export default class PageHeader {
  constructor() {
    // Only if there is an image
    if (!$('.page-header--no-image').length) {
      $clone.insertAfter($wrap);
      this.animate();
    }
  }

  animate() {
    window.requestAnimationFrame(() => this.animate());
    const SCROLL = $(window).scrollTop();
    // console.log(SCROLL);
    const HEADER_HEIGHT = $siteHeader.height();
    const fixed = SCROLL >= HEADER_HEIGHT;
    const PAGE_HEAD_HEIGHT = $wrap.height();
    let opacity = 1;
    let translate = 'translateY(0)';
    let zoom = 'scale(1, 1)';

    if (fixed) {
      $clone.height(PAGE_HEAD_HEIGHT);
      $clone.show();
      const diff = Math.min(TRANSITION_DURATION_IN_PX, SCROLL - HEADER_HEIGHT) / TRANSITION_DURATION_IN_PX;
      const diffZoom = Math.min(HEADER_HEIGHT + PAGE_HEAD_HEIGHT, SCROLL - HEADER_HEIGHT) / (HEADER_HEIGHT + PAGE_HEAD_HEIGHT);
      opacity = 1 - diff;
      translate = `translateY(${easeInCubic(diff) * 20}px)`;
      zoom = `scale(${1 + easeInOutQuart(diffZoom) * 0.05})`;
    }
    else {
      $clone.hide();
      // $title.css({
      //   opacity: 1
      // });
    }

    // Hide fixed header if scrolled enough, otherwise visible over the footer.
    if (SCROLL > HEADER_HEIGHT + PAGE_HEAD_HEIGHT) {
      $wrap.hide();
    }
    else {
      $wrap.show();
    }

    // $title.css({
    //   opacity,
    //   '-webkit-transform' : translate,
    //   '-moz-transform'    : translate,
    //   '-ms-transform'     : translate,
    //   '-o-transform'      : translate,
    //   'transform'         : translate
    // });

    $img.css({
      '-webkit-transform' : zoom,
      '-moz-transform'    : zoom,
      '-ms-transform'     : zoom,
      '-o-transform'      : zoom,
      'transform'         : zoom
    });
    $wrap.toggleClass('is-fixed', fixed);
  }
}



// WEBPACK FOOTER //
// ./3.modules/pageHeader/PageHeader.js